module.exports = __webpack_public_path__ + "static/media/Mobiliario-v2.58ab7d07.png";